exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__3CsQy{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__1mVeX{display:none!important}}@media (max-width:79.9rem){.style_hide-md__XS7Lj{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1huHX{display:none!important}}.style_container__3rXsY{display:flex;padding:1rem;align-items:center;flex-wrap:wrap;justify-content:space-between;min-height:4.25rem}.style_titleContainer__3-W7u{display:flex;flex-direction:column;font-size:1.25rem}.style_header__2STZ0{margin:0;padding:0}.style_title__YSj5Z{display:flex;flex-direction:row;align-items:center;line-height:1.75rem;margin:.25rem 0}.style_logo__13jHw{margin-right:.5rem}.style_refreshContainer__1D4wv{position:relative;height:1.75rem;opacity:.8}.style_refreshIndicator__j1D7G{width:2.5rem}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3CsQy",
	"hideSm": "style_hide-sm__3CsQy",
	"visible-sm": "style_visible-sm__1mVeX",
	"visibleSm": "style_visible-sm__1mVeX",
	"hide-md": "style_hide-md__XS7Lj",
	"hideMd": "style_hide-md__XS7Lj",
	"visible-md": "style_visible-md__1huHX",
	"visibleMd": "style_visible-md__1huHX",
	"container": "style_container__3rXsY",
	"titleContainer": "style_titleContainer__3-W7u",
	"header": "style_header__2STZ0",
	"title": "style_title__YSj5Z",
	"logo": "style_logo__13jHw",
	"refreshContainer": "style_refreshContainer__1D4wv",
	"refreshIndicator": "style_refreshIndicator__j1D7G"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/SectionTitle/style.less
// module id = 1417
// module chunks = 8